import React, { useState, useEffect } from 'react';
import { handleRedirect } from '../../utils/deviceDetection';
import './PaymentLoading.css';

const MobilePaymentLoading = () => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    setTimeout(() => {
      setShowCountdown(true);
      
      let countdownValue = 2;
      const timer = setInterval(() => {
        setCountdown(countdownValue);
        countdownValue--;
        if (countdownValue < 0) {
          clearInterval(timer);
          
            handleRedirect(urlParams, '/mobile/payment-result');
         
        }
      }, 1000);
    }, 1000);
  }, []); 

  return (
    <div className="payment-loading-container">
      <div className="payment-container">
        <div className="logo-container">
          <div className="fws-logo">
            <img src="/assets/images/newlogo.png" alt="FWS Logo" />
          </div>
          <div className="arrow-animation">
            <span className="arrow-text">&gt;&gt;&gt;</span>
          </div>
          <div className="cashfree-logo">
            <img src="/assets/images/CashFreeIcon.svg" alt="Cashfree Payments" />
          </div>
        </div>
        
        <h1>Payment Initialization</h1>
        <p className="subtitle">Preparing your payment... this will just take a moment</p>
        
        {showCountdown && (
          <div className="countdown-text">
            Redirecting in <span className="countdown-number">{countdown}</span> Seconds...
          </div>
        )}
        
        <div className="info-section">
          <h4>What's Happening?</h4>
          <ul>
            <li>Connecting to the payment gateway</li>
            <li>Validating order details</li>
            <li>Securing transaction information</li>
            <li>Redirecting you to the payment page</li>
          </ul>
        </div>
        
        <div className="divider"></div>
        
        <div className="security-section">
          <div className="security-icon">
            <img src="/assets/images/SecureProcessIcon.svg" alt="Secure Process" />
          </div>
          <p className="security-text">
            <strong>Secure Process :</strong> Your payment data will be encrypted and processed securely.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobilePaymentLoading;
